import LoadingButton from '@mui/lab/LoadingButton';
import { Button, ButtonProps } from '@mui/material';

import styles from './Button.module.scss';

export type IButtonProps = Omit<ButtonProps, 'type'> & {
	btnType: 'primary' | 'secondary' | 'tertiary' | 'text' | 'negative';
	children: any;
	clickHandler?: any;
	disabled?: boolean;
	loading?: boolean;
	compClass?: string;
};

const { btnBlue, textWhite, btnGreyHover, btnRedHover, leftSpace, topSpace } =
	styles;

const mapTypeChanges = {
	primary: {
		variant: 'contained' as const,
		className: 'primary-btn',
		bgColor: btnBlue,
	},
	secondary: {
		variant: 'outlined' as const,
		className: 'secondary-btn',
		bgColor: textWhite,
	},
	tertiary: {
		variant: 'contained' as const,
		className: 'tertiary-btn',
		bgColor: btnGreyHover,
	},
	text: {
		variant: 'text' as const,
		className: 'text-btn',
		bgColor: 'none',
	},
	negative: {
		variant: 'contained' as const,
		className: 'negative-btn',
		bgColor: btnRedHover,
	},
};

const ButtonComp = (props: IButtonProps) => {
	const {
		children,
		clickHandler,
		btnType,
		disabled,
		loading,
		compClass,
		...otherprops
	} = props;
	return (
		<div>
			{loading ? (
				<LoadingButton
					disableRipple
					disableTouchRipple
					loading={loading}
					variant={mapTypeChanges[btnType].variant}
					sx={{
						height: '100%',
						padding: `${topSpace} ${leftSpace}`,
						backgroundColor: `${mapTypeChanges[btnType].bgColor} !important`,
						'& .MuiLoadingButton-loadingIndicator': {
							color:
								btnType === 'primary'
									? `${textWhite} !important`
									: `${btnBlue} !important`,
						},
					}}
					{...otherprops}
				>
					{children}
				</LoadingButton>
			) : (
				<Button
					disableRipple
					disableTouchRipple
					onClick={clickHandler}
					variant={mapTypeChanges[btnType].variant}
					className={`${
						styles[mapTypeChanges[btnType].className]
					} ${compClass}`}
					disabled={disabled}
					fullWidth
					{...otherprops}
				>
					{children}
				</Button>
			)}
		</div>
	);
};

export default ButtonComp;
